import React from 'react';
import Layout from './index';

// it receives props from page and pass those props to layout index component
export default (props) => (
  <Layout
    {...props}
  />
);